import Vue from "vue";
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("Tippy", TippyComponent);
import "tippy.js/themes/light.css";
